// export function convertData(data = {}) {
//   // console.log("data", data);
//   return {
//     fields: data.fields?.map((field) => ({
//       fieldSetId: 0,
//       name: field?.properties?.name || "",
//       type: field?.type || "",
//       regEx: field?.properties?.regex || "",
//       listValues: field?.properties?.listValues || "",
//       description: "",
//       label: field?.properties?.label || "",
//       placeholder: field?.properties?.placeholder || "",
//       max: field?.properties?.max || 0,
//       prefix: field?.properties?.prefix || "",
//       postfix: field?.properties?.postfix || "",
//       group: field?.properties?.group || "",
//       dataSource: "",
//       sortOrder: field?.properties?.sortOrder || 0,
//       defaultValue: field?.properties?.defaultValue || "",
//       tooltip: field?.properties?.tooltip || "",
//       width: field?.properties?.styles?.width || 242,
//       length: 0,
//       isRequired: field?.properties?.required || false,
//       isReadOnly: field?.properties?.readOnly || false,
//       isCounter: field?.properties?.counter || false,
//       isDecimal: field?.properties?.decimal || false,
//       parent: 0,
//     })),
//   };
// }

export function convertData(data = {}) {
  const flatFields = [];

  const flattenFields = (fields, parentGroup = "") => {
    fields.forEach((field) => {
      // Ignore container when flattening, but still save it
      const base = {
        fieldSetId: 0,
        name: field?.name || "",
        type: field?.type || "",
        regEx: field?.properties?.regex || "",
        listValues: field?.properties?.listValues || "",
        description: "",
        label: field?.properties?.label || "",
        placeholder: field?.properties?.placeholder || "",
        max: field?.properties?.max || 0,
        prefix: field?.properties?.prefix || "",
        postfix: field?.properties?.postfix || "",
        group: parentGroup || field?.properties?.group || "",
        dataSource: "",
        sortOrder: field?.properties?.sortOrder || 0,
        defaultValue: field?.properties?.defaultValue || "",
        tooltip: field?.properties?.tooltip || "",
        width: field?.properties?.styles?.width || 242,
        length: 0,
        isRequired: field?.properties?.required || false,
        isReadOnly: field?.properties?.readOnly || false,
        isCounter: field?.properties?.counter || false,
        isDecimal: field?.properties?.decimal || false,
        parent: 0,
      };

      flatFields.push(base);

      // If container with children, recursively flatten
      if (field?.type === "container" && Array.isArray(field.children)) {
        flattenFields(field.children, field.name); // Pass container name as group
      }
    });
  };

  flattenFields(data.fields || []);

  return {
    name: data.name,
    sortOrder: data.sortOrder,
    status: data.status,
    fields: flatFields,
  };
}

// export function transformFields(fields = []) {
//   return fields?.map((field, index) => {
//     return {
//       id: field.type,
//       content: capitalize(field.type),
//       type: field.type,
//       icon: {
//         key: null,
//         ref: null,
//         props: {
//           size: 20,
//         },
//         _owner: null,
//         _store: {},
//       },
//       key: `${field.type}-${index}-${Date.now()}`,
//       properties: {
//         name: field.name || "",
//         label: field.label || "",
//         placeholder: field.placeholder || "",
//         counter: field.isCounter || false,
//         readOnly: field.isReadOnly || false,
//         required: field.isRequired || false,
//         decimal: field.isDecimal || false,
//         regex: field.regEx || "",
//         defaultValue: field.defaultValue || "",
//         max: field.max || 0,
//         postfix: field.postfix || "",
//         group: field.group || "",
//         prefix: field.prefix || "",
//         tooltip: field.tooltip || "",

//         sortOrder: field.sortOrder || 0,
//         groupForRadioOrCheckBox: "",
//         listValues: field.listValues || "",
//         options: [
//           {
//             name: "",
//             children: [],
//           },
//         ],
//         styles: {
//           width: field?.width || 242,
//         },
//       },
//     };
//   });
// }

export function transformFields(fields = []) {
  const result = [];
  const containerMap = {};

  fields.forEach((field, index) => {
    const transformedField = {
      id: field.type,
      content: capitalize(field.type),
      type: field.type,
      icon: {
        key: null,
        ref: null,
        props: {
          size: 20,
        },
        _owner: null,
        _store: {},
      },
      key: `${field.type}-${index}-${Date.now()}`,
      name: field.name || "",
      properties: {
        name: field.name || "",
        label: field.label || "",
        placeholder: field.placeholder || "",
        counter: field.isCounter || false,
        readOnly: field.isReadOnly || false,
        required: field.isRequired || false,
        decimal: field.isDecimal || false,
        regex: field.regEx || "",
        defaultValue: field.defaultValue || "",
        max: field.max || 0,
        postfix: field.postfix || "",
        group: field.group || "",
        prefix: field.prefix || "",
        tooltip: field.tooltip || "",
        sortOrder: field.sortOrder || 0,
        groupForRadioOrCheckBox: "",
        listValues: field.listValues || "",
        options: [{ name: "", children: [] }],
        styles: {
          width: field?.width || 242,
        },
      },
    };

    if (field.type === "container") {
      transformedField.children = [];
      containerMap[field.name] = transformedField;
      result.push(transformedField);
    } else if (field.group && containerMap[field.group]) {
      // Add to matching container
      containerMap[field.group].children.push(transformedField);
    } else {
      result.push(transformedField);
    }
  });

  return result;
}

function capitalize(string = "") {
  return string?.charAt(0).toUpperCase() + string?.slice(1);
}
